import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const BatteryExtend = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('battery_item3'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('battery_extend_faq')}</span>
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px' }}>{t('battery_extend_faq_detail')}</span>
            </div>
            <div style={{ height: 20 }} />
        </div>
    </div>
}

export default BatteryExtend